module.exports = __webpack_public_path__ + "static/media/check.624954bc.svg";